import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import { ModelIndexHandle } from "@components/layout/ModelIndex";
import { CreditnoteApi } from "@/api/CreditnoteApi";
import CreditnoteModelIndex from "@components/dynamic/modelIndexes/CreditnoteModelIndex";

const CreditnoteIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      title="Lista de Notas de Credito"
      backUrl="/user/dashboard-accounting"
      primaryActions={[
        {
          onClick: () => {
            navigate('/user/creditnotes/invoice-select/price')
          },
          actionTitle: "Nueva Por Precio",
          color: "success"
        },
        {
          onClick: () => {
            navigate('/user/creditnotes/invoice-select')
          },
          actionTitle: "Nueva",
          color: "success"
        }
      ]}
      secondaryActions={[
        {
          actionTitle: "Cargar XML",
          href: "/user/creditnotes/import"
        }
      ]}
    >
      <CreditnoteModelIndex
        ref={modelRef}
        messages={{
          noResults: "No hay notas de credito creadas aun"
        }}
        fetchData={(...args) => CreditnoteApi.fetchAll(...args)}
      >
      </CreditnoteModelIndex>
    </PageContainer >
  );
}

export default CreditnoteIndex;
